import React, { useState } from "react";

import {
  GridContainer,
  GridItem,
  BtnGroup,
  Overlay,
  ModalContent,
  CloseButton,
  TopContent,
  LeftContent,
  RightContent,
  Title,
  BottomContent,
} from "./SmallCardElement";



function SmallCard({ projects }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);

  // Open modal and set the project data
  const openModal = (project) => {
    setSelectedProject(project);
    setIsModalOpen(true);
  };

  // Close modal
  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedProject(null);
  };

  const handleOverlayClick = (e) => {
    if (e.target.id === "overlay") {
      closeModal();
    }
  };

  return (
    <>
      <GridContainer>
        {projects.map((list, index) => (
          <GridItem key={index}>
            <img src={list.img} alt={list.title} />
            <h4
            ><strong>{list.title}</strong></h4>
            {/* <hr style={{width: '90%'}} /> */}
            <p>{list.description}</p>

            {list.description && (
              <BtnGroup>
                <a
                    className="btn PrimaryBtn btn-shadow"
                    onClick={() => openModal(list)}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Show More
                  </a>
              </BtnGroup>
          )}
          </GridItem>
        ))}
      </GridContainer>

      {/* Modal Overlay */}
      {isModalOpen && (
        <Overlay id="overlay" onClick={handleOverlayClick}>
        <ModalContent>




          <CloseButton onClick={closeModal}>
            x
          </CloseButton>
          {selectedProject && (
            <>

            <TopContent>
              
            {/* <LeftContent> */}
              
            {selectedProject.youtube_url ? (
              <iframe
                  // width="640"
                  // height="360"
                  // 854 x 480 
                  width="854"
                  height="480"
                  src={`https://www.youtube.com/embed/${selectedProject.youtube_url}`}
                  title={selectedProject.title}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
              ></iframe>
              ) : (
                  <img src={selectedProject.img} alt={selectedProject.title} />
              )}
            {/* </LeftContent> */}
            {/* <RightContent> */}
              {/* <Title ><strong>{selectedProject.title}</strong></Title> */}
              {/* <p>{selectedProject.project}</p>
              <p>{selectedProject.contribution}</p>
            </RightContent> */}
            </TopContent>
            <BottomContent> 
              <Title><strong>{selectedProject.title}</strong></Title>
              <p>{selectedProject.detailed}</p>

            </BottomContent>
            </>
          )}
        </ModalContent>
      </Overlay>
      )}
    </>
  );
}

export default SmallCard;
